import TelecallerApi from "../../services/api/Telecaller";
import { getQueryParams } from "../../utils";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in telecaller actions:", err);
}

export const setTelecallerProfiles = (payload) => {
  return {
    type: ActionTypes.SET_TELECALLER_PROFILES,
    payload,
  };
};

export const setActiveTelecaller = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_TELECALLER,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_TELECALLER,
    payload,
  };
};

export const setCurrentPageTelecallers = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_TELECALLERS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_TELECALLER,
    payload,
  };
};

export const setClustersTelecaller = (payload) => {
  return {
    type: ActionTypes.SET_CLUSTERS_TELECALLER,
    payload,
  };
};

export const getTelecallerProfiles =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...filters,
        ...pageRequest,
      };
      const payload = getQueryParams(finalPayload);
      dispatch(setLoader(true));
      let response = await TelecallerApi.getTelecallerProfiles(payload);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setTelecallerProfiles(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageTelecallers(pageRequest.page_number));
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getTelecaller = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await TelecallerApi.getTelecaller(id);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActiveTelecaller(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateTelecaller = (id, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await TelecallerApi.updateTelecaller(id, payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(resetState({ state: "activeTelecaller" }));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getClustersTelecaller = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await TelecallerApi.getClusters();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setClustersTelecaller(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
